import colors from "assets/theme/base/colors";

function getPieChartData(salesSummaryList) {
  // param: salesSummaryList: lista the objetos tipo list<SalesSummaryModel>
  console.log("getPieChartData");
  const default_label = "Ventas Anuales";
  var labels = [];
  var colors_list = [];
  var data = [];
  const top = 5;

  // get total sales per year
  var totalSales = 0;
  salesSummaryList.forEach((elem) => {
    totalSales = totalSales + Number(elem.total);
  });

  const topCompanies = salesSummaryList.slice(0, top);
  const colorList = Object.keys(colors.gradients);

  let topSales = 0;
  topCompanies.forEach((elem, index) => {
    labels.push(elem.company);
    colors_list.push(colorList[index]);
    data.push(Number(elem.total));
    topSales += Number(elem.total);
  });

  labels.push("Otras");
  colors_list.push("light");
  data.push(totalSales - topSales);

  // return values in a format that charts components understand
  return {
    labels: labels,
    datasets: {
      label: default_label,
      backgroundColors: colors_list,
      data: data,
    },
  };
}

export default getPieChartData;
